import React, {useState} from 'react';
import {useObsidianContext} from '../../../../context/ObsidianProvider';
import {useCurrentSongContext} from '../../../../context/CurrentSongProvider';

import styles from './ProgressBar.module.scss';

interface Props {
  position: number;
  length?: number;
}

export default function ProgressBar({position, length}: Props) {
  const percent = length ? (position * 100) / length : 0;
  const [isScrubbing, setIsScrubbing] = useState(false);
  const [scrubbingPosition, setScrubbingPosition] = useState<number | null>(0);
  const {song, buffer} = useCurrentSongContext();
  const {obsidian} = useObsidianContext();

  function getPositionValue(e: React.SyntheticEvent<HTMLInputElement>): number {
    return ((e.target as HTMLInputElement).value as unknown) as number;
  }

  function onScrub(e: React.SyntheticEvent<HTMLInputElement>) {
    setScrubbingPosition(getPositionValue(e) * 1);
  }

  function onStartScrubbing(e: React.SyntheticEvent<HTMLInputElement>) {
    if (!song) return;
    setIsScrubbing(true);
    setScrubbingPosition(getPositionValue(e) * 1);
  }

  async function onEndScrubbing(e: React.SyntheticEvent<HTMLInputElement>) {
    if (!song) return;
    obsidian.seek(getPositionValue(e) * 1, () => {
      setIsScrubbing(false);
      setScrubbingPosition(null);
    });
  }

  function getScrubberValue() {
    if (isScrubbing && scrubbingPosition) {
      return scrubbingPosition;
    }

    return position;
  }

  return (
    <div className={styles.ProgressBar}>
      <span className={styles.Position}>{formatMs(position)}</span>
      <input
        className={styles.progressBar}
        style={{
          background: `linear-gradient(
              to right,
              #646464 0%,
              #646464 ${percent}%,
              #cccccc ${percent}%,
              #cccccc ${buffer}%,
              #eeeeee ${buffer}%,
              #eeeeee 100%
            ) no-repeat`,
        }}
        type={'range'}
        value={getScrubberValue()}
        onChange={onScrub}
        onMouseDown={onStartScrubbing}
        onTouchStart={onStartScrubbing}
        onMouseUp={onEndScrubbing}
        onTouchEnd={onEndScrubbing}
        min={0}
        max={length}
        step={1}
      />
      <span className={styles.Length}>{formatMs(length)}</span>
    </div>
  );
}

function formatMs(ms?: number) {
  if (!ms) {
    return '0:00';
  }
  const minutes = Math.floor(ms / 1000 / 60);
  const seconds = Math.floor((ms / 1000) % 60);
  const paddedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${paddedSeconds}`;
}
